import Service from "../../../Services/index";

const ExportProducts = {
    namespaced: true,
    state: {
        table: [],
        replace_data: [],
        dataPaginate:{
            current_page :1,
            from : 1,
            last_page : 1,
            per_page : 1,
            total : 1,
            to : 1
        }
    },
    mutations: {
        REPLACE_DATA: (state, res) => {
            state.replace_data = res;
        }
    },
    actions: {
        get({ commit },page=1) {
            return Service.ExportProduct.getExportProducts(page);
        },
        show({ commit }, id)   {
            return Service.ExportProduct.showExportProducts(id).then(
                response => {
                    commit("REPLACE_DATA", response);
                }
            );
        },
        create({ commit }, data) {
            return Service.ExportProduct.createExportProducts(data);
        },
        update({ commit }, { id, data }) {
            return Service.ExportProduct.updateExportProducts(id, data);
        },
        delete({ commit }, id) {
            return Service.ExportProduct.deleteExportProducts(id);
        },
        search({ commit }, {page="", code, date }) {
            return Service.ExportProduct.searchExportProducts(page,code, date);
        }
    }
};
export default ExportProducts;
